import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom'

// components
import AppCard from '../../components/AppCard'
import AppForm from '../../components/form/form-letter-number/AppForm'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'
import AppModalConfirmation from '../../components/modal/AppModalConfirmation'

// helpers
import Axios from '../../helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

const AddLetter = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { showSuccess, showError } = useToastMessage();

  const isLoading = useSelector((state) => state.isLoading)

  const [letterType, setLetterType] = useState(null)
  const [showModalConfirm, setShowModalConfirm] = useState({ show: false })

  const formik = useFormik({
    initialValues: {
      letter_type: '',
      letter_recipient: '',
      letter_notes: ''
    },
    validationSchema: Yup.object().shape({
      letter_type: Yup.string()
        .required("Please select letter type."),
      letter_recipient: Yup.string()
        .required("Please enter letter recipient."),
      letter_notes: Yup.string().required("Please enter letter notes."),
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  const handleInputValue = (values) => {
    let data = {
      letter_type: values.letter_type,
      letter_recipient: values.letter_recipient,
      letter_notes: values.letter_notes
    }

    return data
  }

  const handlePost = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "post",
      url: `/api/tracker/v1/generalsetting/create/letternumber`,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          showSuccess("Letter number has been created successfully.")
          navigate('/letter-no-tracker/list')
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      });
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handlePost(inputPayload)
  }

  const handleSubmit = () => {
    formik.handleSubmit()

    setShowModalConfirm({ show: false })
  }

  const handleSelectLetterType = (data) => {
    formik.setValues((values) => ({
      ...values,
      letter_type: data ? data?.value : ''
    }))
    setLetterType(data ? data : null)
  }

  return (
    <>
      {
        showModalConfirm.show && (
          <AppModalConfirmation 
            confirmationType="confirmation"
            showModal={showModalConfirm}
            setShowModal={setShowModalConfirm}
            headerTitle="Confirmation"
            descriptionText="Are you sure want create a new letter number?"
            handleSubmit={handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
          />
        )
      }
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Add Letter Number</h4>}
        bodyContent={
          <AppForm 
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
            handleSelectLetterType={handleSelectLetterType}
            letterType={letterType}
          />
        }
        footerContent={
          <ActionButtonForm
            isLoading={isLoading}
            disabled={formik.isSubmitting}
            onCancel={() => navigate('/letter-no-tracker/list')}
            onSave={() => setShowModalConfirm({ show: true })}
          />
        }
      />
    </>
  )
}

export default AddLetter